<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white">
      {{ isNewInstrument ? 'New ' : ''}}Instrument
    </div>
    <div class="card-body">
      <LoadingSpinner v-if="submitting" message ='Saving Instrument' size = '1x'>
      </LoadingSpinner>
      <template v-if="!submitting">
        <div class="form-group row">
          <label for="agreementType" class="col-lg-4 col-form-label label-text">
            <span class="text-danger">*</span>Agreement Type
          </label>
          <div class="loading col-lg-5" v-if="loading">
            Loading...
          </div>
          <div class="col-lg-8">
            <select v-if="!loading"
                    v-validate="'required'"
                    data-vv-as="Agreement Type"
                    class="form-control"
                    name="agreementType"
                    v-model="propertyInstrument.instrument.agreementTypeId">
              <option value="" disabled>Select Agreement Type</option>
              <option v-for="option in agreementTypeOptions"
                      :key="option.id"
                      :value="option.id">
              {{ option.name }}
              </option>
            </select>
            <div class="invalid-feedback">{{ errors.first('agreementType') }}</div>
          </div>
        </div>
        <div class="form-group row" v-if="!isNewInstrument">
          <label for="impactedPropertyAcres" class="col-lg-4 col-form-label label-text">
            <span class="text-danger">*</span>Impacted Property Acres
          </label>
          <div class="col-lg-8">
            <input v-validate="'required|max_decimal:4|min_value:0.0000'"
              data-vv-as="Impacted Property Acres"
              type="text"
              class="form-control"
              name="impactedPropertyAcres"
              v-model="propertyInstrument.propertyAcres"
              placeholder="Enter Impacted Property Acres"
              />
            <small v-if="!errors.first('impactedPropertyAcres')" class="form-text text-muted">
              Max 4 decimal places
            </small>
            <div class="invalid-feedback">{{ errors.first('impactedPropertyAcres') }}</div>
          </div>
        </div>
        <hr>
        <div class="form-group row">
          <label class="col-lg-4 label-text">
            <span v-if="!isNewInstrument" class="text-danger">*</span>Primary Contact
          </label>
          <div class="col-lg-8">
            {{ propertyInstrument.instrument.contacts[0] | contactNameOrDefault }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-4 label-text">
            <span v-if="!isNewInstrument" class="text-danger">*</span>Address
          </label>
          <div class="col-lg-8"
            v-html="$options.filters.contactAddress(propertyInstrument.instrument.contacts[0])">
          </div>
        </div>
        <SearchContactsModal
          :modalId="'contactSearch'"
          :parentType="'instrument'"
          :disableExisting="!isNewInstrument"
          @set-contact="updateContact"
        />
        <div v-if="contactError" class="invalid-feedback d-block">Primary Contact is required.</div>
        <slot name="additionalFields"></slot>
      </template>
    </div>
    <slot name="submitForm"></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import SearchContactsModal from './contacts/SearchContactsModal.vue';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'InstrumentForm',
  props: [
    'propertyInstrument',
    'contactError',
    'isNewInstrument',
    'submitting',
  ],
  components: {
    SearchContactsModal,
    LoadingSpinner,
  },
  // this injects the parent page's validator
  inject: ['$validator'],
  created() {
    this.$store.dispatch(`${LookupModules.AGREEMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.AGREEMENT_TYPES.url);
  },
  computed: {
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      loading: state => state.loading,
      serverError: state => state.serverError,
    }),
    ...mapGetters(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptions: 'getActiveOptions',
    }),
  },
  methods: {
    updateContact(contactResult) {
      this.$emit('set-instrument-contact', contactResult);
    },
  },
};
</script>
